import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const cloudGatewaysRoutes = {
  [ERouteMappingKeys.CLOUD_GATEWAYS]: {
    id: "cloud-gateways",
    path: "/cloud-gateways",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/CloudGateways/Overview").then((p) => ({
          default: p.CloudGatewaysOverview,
        })),
      ),
      "resource-calculator": lazy(() =>
        import("pages/Sections/CloudGateways/ResourceCalculator").then((p) => ({
          default: p.ResourceCalculator,
        })),
      ),
      "enterprise-scale": lazy(() =>
        import("pages/Sections/CloudGateways/EnterpriseScale").then((p) => ({
          default: p.EnterpriseScale,
        })),
      ),
      "large-scale": lazy(() =>
        import("pages/Sections/CloudGateways/LargeScale").then((p) => ({
          default: p.LargeScale,
        })),
      ),
      "wifi-integrated": lazy(() =>
        import("pages/Sections/CloudGateways/WiFiIntegrated").then((p) => ({
          default: p.WiFiIntegrated,
        })),
      ),
      compact: lazy(() =>
        import("pages/Sections/CloudGateways/Compact").then((p) => ({
          default: p.Compact,
        })),
      ),
    },
  },
};
